import PrivateChatContainer from "../../../../Component/Application/Chat/Chating/Chating"

const PrivateChat = () => {
  return (
    <div className='page-body'>
      <PrivateChatContainer />
    </div>
  )
}

export default PrivateChat